<template>
  <div class="hl_settings--body">
    <AppReviewComponent id="marketplace-review-templates-embed" :config="config" v-if="config.route_name=='marketplace-templates-review'" />
    <AppReviewComponent id="marketplace-review-table-embed" :config="{}" v-else-if="$route.name=='marketplace-apps-review'" />
    <AppReviewComponent id="marketplace-review-app-embed" :config="{}" v-else-if="$route.name=='marketplace-app-new'" />
   
  </div>
</template>

<script>
export default {
  props:{
    config:{
      type:Object,
      default:()=>({})
    }
  },
  components: {
    AppReviewComponent: () => import("./AppReviewComponent.vue"),
  },
};
</script>
